import styled from 'styled-components/macro';

import { PopupTextArea, ErrorMessage } from '../Popups.styles';
import { DropdownSelect } from '../../common/formElements';

export const ReasonDropdownSelect = styled(DropdownSelect)`
  margin: 0 auto;
`;

export const ValidationErrorMessage = styled(ErrorMessage)`
  margin-bottom: 5px;
`;

export const EscalateMessageTextArea = styled(PopupTextArea)`
  margin-top: 10px;
  border-radius: 4px;
  padding: 4px 6px;
  height: 70px;
`;

export const StyledSubheading = styled.h4`
  font-size: 14px;
  display: block;
  text-align: left;
  margin-bottom: 10px;
`;
